import { MarketingBar, PageHeader } from 'design-system';

import useLinkBar from '@/app/components/AppTopBar/useLinkBar';
import renderSanitizedHtml from '@/shared/lib/renderSanitizedHtml';
import { useRouteMeta } from '@/shared/pageTitle';

/**
 * The fixed application topbar: a `Section / Title` breadcrumb resolved from
 * route metadata on the left, and the datalake-driven marketing chip on the
 * right (hidden when there is no link content).
 */
const AppTopBar = () => {
  const { title, section } = useRouteMeta();
  const { linkUrl, linkMessage } = useLinkBar();

  return (
    <PageHeader
      title={title}
      section={section}
      action={
        linkUrl && linkMessage ? (
          <MarketingBar
            href={linkUrl}
            target='_blank'
            rel='noopener noreferrer'
          >
            {renderSanitizedHtml(linkMessage)}
          </MarketingBar>
        ) : null
      }
    />
  );
};

export default AppTopBar;
